// initial state
const state = {
    snack: false,
    snackColor: '',
    snackText: '',
  }
  
  // getters
  const getters = {
  }
  
  // actions
  const actions = {
    
  }
  
  // mutations
  const mutations = {
    setStatus (state, statusData) {
      state.snack = statusData.snack
      state.snackColor = statusData.snackColor
      state.snackText = statusData.snackText
    }
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }